<template>
  <div>
    <ModuleHeader>Reporte cuentas por cobrar</ModuleHeader>
    <v-row>
      <v-col md="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col md="4" cols="12">
                <v-menu
                  v-model="menuFechaInicial"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="input_date"
                      label="Fecha Inicial"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="input_date"
                    @input="menuFechaInicial = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="4">
                <v-menu
                  v-model="menuFechaInicial2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="input_date_final"
                      label="Fecha Final"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="input_date_final"
                    @input="menuFechaInicial2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="4">
                <v-autocomplete
                  label="Cuenta"
                  item-value="Id"
                  item-label="text"
                  v-model="selectClient"
                  multiple
                  :items="data_clientes"
                ></v-autocomplete>
              </v-col>
              <v-col class="text-right mt-n5" md="12">
                <v-btn
                  depressed
                  @click="cleanFilter()"
                  class="mx-2"
                  color="error"
                  >Restablecer Filtro</v-btn
                >
                <v-btn depressed @click="getCuentas()" color="success"
                  >Buscar</v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-btn color="green" dark @click="exportExcel()">
      <v-icon>mdi-file-excel-box</v-icon>Exportar a Excel
      <!-- <download-excel type="xls" name="Cuentas por cobrar" :data="excel_data"
        ></download-excel 
      >-->
    </v-btn>
    <v-btn color="red" @click="generatePdf()" dark>PDF</v-btn>
    <v-simple-table>
      <thead>
        <th>Fecha</th>
        <th>Descripción</th>
        <th>Cant</th>
        <th>Monto</th>
      </thead>
      <tbody>
        <template v-for="(item, index) in dataProcessed">
          <tr
            style="background: #ddd8d8"
            :key="index + 'header'"
            v-if="item.header"
          >
            <td colspan="4">{{ item.text }}</td>
          </tr>
          <tr :key="index + 'header'" v-if="!item.header && !item.footer">
            <td>{{ item.fecha }}</td>
            <td>{{ item.Nombre }}</td>
            <td>{{ item.Cnt }}</td>
            <td>{{ $pgsHelper.formatNumber(item.Cnt * item.Pco.C) }}</td>
          </tr>
          <tr
            style="background: #ddd8d852"
            :key="index + 'footer'"
            v-if="item.footer"
          >
            <td colspan="3">
              <b>{{ item.text }}</b>
            </td>
            <td>
              <b>{{ $pgsHelper.formatNumber(item.total) }}</b>
            </td>
          </tr>
        </template>
      </tbody>
    </v-simple-table>
    <uv-data-table
      v-if="false"
      :config="config"
      :data="Cuentas"
      :pageRows="141"
      @buttonClick="dtButtonClick"
      @buttonOptClick="optButtonClick"
    ></uv-data-table>
    <modal v-model="showModal" :showFooter="false" title="Cuenta">
      <formCuenta
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      ></formCuenta>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import formCuenta from "./CxCDetail.vue";
import Cliente from "../../../clases/Cliente.js";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import Reportecxc from "../../../clases/PdfMakers/Reportecxc.js";
import moment from "moment";
import ReporteCxcExporter from "../../../clases/ExcelMaker/ReporteCxCExcel.js";
export default {
  name: "CuentaCRUD",
  components: {
    modal,
    uvDataTable,
    formCuenta,
  },
  props: [],
  data() {
    return {
      selectClient: [],
      Cuentas: [],
      menuFechaInicial: false,
      menuFechaInicial2: false,
      input_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      input_date_final: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      MainDepartamento: "",
      self: this,
      showModal: false,
      formKey: 0,
      formIndex: 0,
      editMode: false,
      Categories: [],
      editData: [],
      products: [],
      hoteles: [],
      usuarios: [],
      editedHotel: {},
      dataProcessed: [],
      //data_clientes: "",
      config: {
        disablePagination: true,
        selectableRow: true,
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "", Type: "Asc" },
        buttons: [],
        fields: [
          {
            title: "Cliente",
            dataName: "NombreCompleto",
            text: "Cliente",
            value: "",
          },
          {
            text: "Fecha creación",
            value: "FechaCreacion",
            format: (row) => {
              let d = new Date(row["FechaCreacion"]);
              return new moment(d).format("DD-MM-YYYY HH:mm");
            },
          },
          {
            title: "Total Cuenta",
            dataName: "Totales",
            text: "Total Cuenta",
            value: "total",
            format: (row) => {
              //et total = (row.Totales.MXN)?Number(row.Totales.MXN):Number(row.Totales.USD)
              return this.$pgsHelper.formatNumber(row.total ? row.total : 0);
              /*return (
                "$" +
                this.$pgsHelper.formatNumber(((row["Totales"].MXN)?row["Totales"].MXN:row["Totales"].USD))) +
                ((row["Totales"].MXN)?' MXN':" USD")
              );*/
            },
          },
          {
            title: "Moneda",
            dataName: "Totales",
            text: "Moneda",
            value: "moneda",
          },

          {
            title: "Productos",
            dataName: "Catalogo", //'Existencia',
            text: "Productos",
            value: "Catalogo",
            format: (row) => {
              return row["Catalogo"].length;
            },
          },
          {
            text: "Opciones",
            value: "id",
            buttons: [
              {
                color: "green",
                text: "Detalle",
                buttonId: "viewDetail",
                value: "id",
              },
            ],
          },
        ],
      },
    };
  },
  methods: {
    exportExcel() {
      ReporteCxcExporter.generateExcelBuffer(this.dataProcessed)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "Cuentas por cobrar.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => console.error("Error exportando Excel:", err));
    },
    generatePdf() {
      let mainData = {
        FI: this.input_date,
        FF: this.input_date_final,
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        data: this.dataProcessed,
      };
      let docData = Reportecxc.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "viewDetail") {
        this.formIndex++;
        this.editMode = true;
        let prodEdit = this.$pgsHelper.getById(this.Cuentas, "id", idSelected);
        this.editData = prodEdit;
        this.showModal = true;
      }
    },
    optButtonClick(buttonId, ref) {},

    successData(data) {
      this.$pgsHelper.log(data);
      let sendData = {
        FechaCreacion: Date.now(),
        Mayoristas: {},
        Departamentos: {},
        Moneda: "USD",
        Precio: parseFloat(data.costoCupon),
        Nombre: data.nombre,
        Tipo: "Cupon",
        Activo: data.status,
        UsosVenta: data.cuponesIlimitados ? null : data.cantidad,
      };
      /*let catalogo = [];
        data.productos.forEach(element => {
            catalogo.push({
                    Id: element.id,
                    CantVenta: element.CantidadCupon,
                    MndaContable: "USD",
                    MndaMayorista: "USD",
                    Tipo:element.Tipo,
                    Origen: element.Origen,
                    PrcoContable: element.PrecioContable,
                    PrcoMayorista: element.PrecioMayorista,
                    }
            );  
        });*/
      sendData.Catalogo = data.productos;
      sendData.Mayoristas[data.mayorista] = true;
      sendData.Departamentos[this.MainDepartamento] = true;
      this.$pgsHelper.log(sendData);
      if (data.Id == "" || !data.Id) {
        this.createCupon(sendData);
      } else {
        sendData.Id = data.Id;
        this.editCupon(sendData);
      }
    },
    createCupon(datos) {
      this.$swal({
        title: "¿Deseas agregar este cupón?",
        text: "Podras editarlo cuando quieras",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Agregar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Cupones-crearCuponMayorista", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          // this.$emit('reloadClient');
          if (result.value.data.ok) {
            this.$swal({
              allowOutsideClick: false,
              title: "Guardado",
              text: "El cupón se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getCupons();
            });
          } else {
            this.$swal(
              "Error guardando Datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    deleteCupon(id) {
      let datos = { Id: id, Departamento: this.MainDepartamento };
      this.$swal({
        title: "¿Deseas eliminar este cupón?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Cupones-eliminarCuponMayorista", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "El cupón se elimino correctamente",
              "El cupón se elimino correctamente",
              "success"
            );
            this.getCupons();
          } else {
            this.$swal(
              "Error eliminando datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },

    editCupon(datos) {
      this.$swal({
        title: "¿Deseas editar el cupón?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        allowOutsideClick: false,
        cancelButtonColor: "#d33",
        confirmButtonText: "Editar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Cupones-editarCuponMayorista", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              allowOutsideClick: false,
              text: "El cupón se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getCupons();
            });
          } else {
            this.$swal(
              "Error guardando información",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    cleanFilter() {
      this.input_date = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.input_date_final = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      this.selectClient = [];
    },
    async getCuentas() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("PDV_CuentaConsumo", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);
      let cuentas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      let cuentasArray = [];
      cuentas.forEach((element) => {
        element.clienteData = Cliente.getById(element.Cliente);
        element.NombreCompleto = element.clienteData
          ? element.clienteData.getNombreCompleto()
          : "Sin Cliente";
        cuentasArray.push(element);
      });
      cuentasArray.forEach((account) => {
        account.total = account.Totales.MXN
          ? account.Totales.MXN
          : account.Totales.USD
          ? account.Totales.USD
          : 0;
        account.moneda = account.Totales.MXN ? "MXN" : "USD";
      });
      let arrayData = this.$_.orderBy(cuentasArray, "total", "desc");
      if (this.selectClient.length > 0) {
        arrayData = arrayData.filter((cuenta) =>
          this.selectClient.includes(cuenta.Cliente)
        );
      }
      this.Cuentas = this.$pgsHelper.cloneObj(arrayData);
      this.processData();
    },
    getDateFormat(data) {
      return moment(data);
    },
    processData() {
      let data = [];

      this.Cuentas.forEach((cuenta) => {
        /*if(cuenta.NombreCompleto != nombreCliente){
            data.push({header:true,text:cuenta.NombreCompleto})
        }*/
        cuenta.Catalogo.forEach((prod) => {
          prod.fecha = prod.ExtraParams.CuentaData.Crat
            ? this.getDateFormat(prod.ExtraParams.CuentaData.Crat).format(
                "YYYY-MM-DD HH:mm"
              )
            : "Otros";
          prod.date = prod.ExtraParams.CuentaData.Crat
            ? this.getDateFormat(prod.ExtraParams.CuentaData.Crat).format(
                "YYYY-MM-DD"
              )
            : "Otros";
          prod.cuentaInfo = cuenta;
          if (
            (prod.date >= this.input_date) &
            (prod.date <= this.input_date_final)
          ) {
            data.push(prod);
          }
        });
        //nombreCliente = cuenta.NombreCompleto
      });
      let nombreCliente = "";
      let total = 0;
      let groupedData = [];
      data.forEach((datos, index) => {
        if (datos.cuentaInfo.NombreCompleto != nombreCliente) {
          groupedData.push({
            header: true,
            text: datos.cuentaInfo.NombreCompleto,
          });
        }
        groupedData.push(datos);
        total += Number(datos.Cnt * datos.Pco.C);
        nombreCliente = datos.cuentaInfo.NombreCompleto;
        if (data[index + 1]) {
          if (
            data[index + 1].cuentaInfo.NombreCompleto !=
            datos.cuentaInfo.NombreCompleto
          ) {
            groupedData.push({
              footer: true,
              text: "Total",
              total: total,
            });
            total = 0;
          }
        } else {
          groupedData.push({
            footer: true,
            text: "Total",
            total: total,
          });
          total = 0;
        }
      });
      this.dataProcessed = groupedData;
    },

    getCuponById(code) {
      let itemIndex = this.$_.findIndex(this.global_cupon, { id: code });
      if (itemIndex >= 0) {
        return this.global_cupon[itemIndex];
      }

      return false;
    },
  },
  computed: {
    data_clientes() {
      let data = Cliente.getClientsList();

      data.forEach((cliente) => {
        cliente.value = cliente.id;
        cliente.text = cliente.getNombreCompleto();
      });
      return data;
    },
    excel_data() {
      let datos = [];
      this.dataProcessed.forEach((cuenta) => {
        if (!cuenta.header & !cuenta.footer) {
          datos.push({
            Nombre: cuenta.cuentaInfo.NombreCompleto,
            Decripcion: cuenta.Nombre,
            Fecha: cuenta.fecha,
            Cantidad: cuenta.Cnt,
            Total: cuenta.Cnt * cuenta.Pco.C,
          });
        }
      });
      return datos;
    },
  },
  watch: {},
  async mounted() {
    //await this.getClientes();
    //await this.getCuentas();
  },
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
  },
};
</script>
